module.exports = {
  front_name: 'myWO',
  back_name: 'myWO',
  contact_phone: '+33149023000',
  contact_email: 'serviceclientfrance@mywo.fr',
  logo: '/images/logo-mywo.svg',
  logo_white: '/images/logo-my-wo-white.svg',
  logo_full: '/images/logo_myWO_full.svg',
  dev_url: 'http://localhost:1101/',
  prod_url: 'https://mywo.fr/',
  pre_prod_url: 'https://mywo-dev.panda-one.dev/',
  captcha_v3_key: '6LcnBJwkAAAAAJwMAjdK6lBL5Q9a6tVLMRLHHABe',
  prod_captcha_v3_key: '6LdnlTQbAAAAAPU7WwSR-uG17btliBdP45oeOJGf',
  MAPS_API_KEY: 'AIzaSyCzOlth-g4C-dkCMXgA8JdI9B-CilEpJO4',
  PROD_MAPS_API_KEY: 'AIzaSyDIct8PhaN3Z-Eof_B8gbdbX1BTZ_iEA-s',
  // In development, override all email addresses, MUST be a string
  DEV_EMAIL: 'support@panda-one.fr',
  PROD_SAFERPAY_API: 'https://www.saferpay.com',
  SAFERPAY_API: 'https://test.saferpay.com',
  admin_receiver: ['support@panda-one.fr'],
  admin_sender: 'myWO <noreply@mywo.fr>',
  languages: [{
    ISO: 'FR',
    label: 'Français'
  }],
  site_name: 'myWO - L\'espace de travail qui vous ressemble',
  meta_description: 'myWO propose une alternative aux bureaux fermés au travers d’espaces de coworking sur-mesure destinés à des travailleurs nomades.',
  social_networks: {
    facebook: 'https://www.facebook.com/Mywo.coworking',
    instagram: 'https://www.instagram.com/mywo_fr'
  },
  ALLOWED_MIN_OVERFLOW: 15
};
